package com.havn.app.core.platform

actual fun havnIsTabletDevice(): Boolean = false

actual fun havnShouldAvoidFloatingNumericKeyboard(): Boolean = false
